import Swiper, { Navigation } from "swiper";

// eslint-disable-next-line no-unused-vars
const swiper = new Swiper(".partners__slider", {
  modules: [Navigation],
  wrapperClass: "partners__wrapper",
  slideClass: "partners__slide",
  slidesPerView: 2,
  breakpoints: {
    414: {
      slidesPerView: 3
    },
    768: {
      slidesPerView: 4
    },
    1024: {
      slidesPerView: 6
    }
  },
  navigation: {
    prevEl: ".partners__button_prev",
    nextEl: ".partners__button_next"
  }
});
